import {
  HasErrorHelperParams,
  HasErrorHelperReturn,
} from './ConnectedUniversalSearch.types';

export const hasErrorHelper = ({
  hasGisSearchAccess,
  searchTerm = '',
  minLength = 4,
  searchType = '',

  gisError = false,
  adrError = false,
  mafError = false,
  what3wordsError,
  isValidW3W = true,

  selectedLocation = null,
}: HasErrorHelperParams): HasErrorHelperReturn => {
  const hasSearch = (searchTerm?.length ?? 0) >= minLength;
  if (!hasSearch) {
    return {
      hasError: false,
      displayResultContainer: false,
    };
  }

  const w3wInvalid = !!what3wordsError || !isValidW3W;
  const adrOrMaf = !!adrError || !!mafError;
  const gisOrMaf = !!gisError || !!mafError;
  const selectionMatches =
    selectedLocation?.attributes?.LongLabel === searchTerm;

  const errCond = hasGisSearchAccess
    ? gisOrMaf || w3wInvalid || adrOrMaf
    : w3wInvalid || adrOrMaf;

  const hasError = !!errCond;

  const displayResultContainer =
    (searchType !== '/maf' && (!selectedLocation || !selectionMatches)) ||
    hasError;

  return { hasError, displayResultContainer };
};
